import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ClientDto } from '../../../../interfaces/Dtos/client.dto';

@Injectable({
  providedIn: 'root'
})
export class ClientService implements AsyncValidator {

  url: string = environment.urlBaseService

  constructor(private httpClient: HttpClient) { }

  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {
    return this.RepeatCode(control.value)
  }

  GetClients(): Observable<any> {
    return this.httpClient.get<any>(`${this.url}client`)
  }

  GetClientTypes(): Observable<any> {
    return this.httpClient.get<any>(`${this.url}client/clienttypes`)
  }

  AddClient(client: ClientDto): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(client)
    return this.httpClient.post(`${this.url}client`, body, { headers })
  }

  EditClient(clientId: number, clientDto: ClientDto): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(clientDto)
    return this.httpClient.put(`${this.url}client?clientid=${clientId}`, body, { headers })
  }

  DeleteClient(id: number): Observable<any> {
    return this.httpClient.delete(`${this.url}client/${id}`)
  }

  RepeatCode(code: string): Observable<any> {
    return this.httpClient.get(`${this.url}client/repeatcode/${code}`)
  }

}
